import styled from "styled-components";

const Block = styled.div`
  .max-1200p {
    width: 100%;
    max-width: 1200px;
    display: flex;
  }

  .header {
    height: 200px;
    background: #bb0665;
    display: flex;
    justify-content: center;
    color: white;

    .h-center {
      display: flex;
    }

    .v-center {
      height: 200px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .logo {
      width: 200px;
      filter: brightness(0) saturate(1) invert(1);
    }

    .logo-text {
      font-family: "Gothic", sans-serif;
      font-size: 2rem;
      font-weight: 500;
      margin-right: 20px;
    }

    .campus-text {
      font-size: 2.5rem;
      font-weight: 600;
    }

    .exit {
      padding-top: 5px;
      padding-right: 10px;

      * {
        font-size: 40px;
      }
    }
  }

  .body {
    display: flex;
    justify-content: center;

    .phonebox {
      margin-top: 50px;
      text-align: center;
      border: none;

      table {
        width: 500px;
        height: 200px;

        th, td {
          width: 250px;
          vertical-align: middle;
          font-size: 2rem;
        }

        td {
          font-weight: 600;
        }
      }
    }

    .left-box {
      padding-top: 100px;
      font-weight: 600;
      flex-basis: 60%;

      .date {
        font-size: 3rem;
      }

      .time {
        margin-top: -10px;
        font-size: 4rem;
      }

      .form-control {
        height: 100px;
        font-size: 5rem;
        text-align: center;
      }
    }

    .right-box {
      flex-basis: 40%;

      .dials {
        width: 400px;
        margin-left: 20px;
        display: flex;
        flex-wrap: wrap;

        .dial {
          width: 100px;
          height: 90px;
          margin-right: 5px;
          margin-bottom: 5px;
          border: 1px solid #bbb;
          border-radius: 4px;
          color: #666;
          font-size: 4.5rem;
        }

        .confirm {
          font-size: 2rem;
          font-weight: 600;
          line-height: 90px;
        }
      }
    }

    .guide-text {
      font-size: 3rem;
    }

    .confirm-button {
      color: white;
      background: #f7ad00;
      width: 200px;
      font-size: 2rem;
    }
  }
`;

export default Block;
